import React  from 'react';
import { OthelloReportViewer } from './OthelloReportViewer';
import OthelloWaiting from './OthelloWaiting';

export default function CPageReportViewer({ ...props })
{    
    //Gestion de la lista de entregas traspasos
    const [loading, setLoading] = React.useState(true);
  
    const [data, setData] = React.useState("");
    const [listado, setListado] = React.useState("");
     

    React.useEffect(() =>
    {
        var listado = localStorage.getItem("pageListado");
        var data = localStorage.getItem("pageData");
       
        if (listado != null && listado != "")
            setListado(listado);

        if (data != null && data != "")
            setData(data);
        
        setLoading(false);

    }, [loading]);
  
    return (
        <div style={{ width: "100%", height: "1000px" }}>
            {loading ? <OthelloWaiting /> : <OthelloReportViewer listado={listado} data={data} />}
        </div>
    );  
}

CPageReportViewer.propTypes = {


}
